import { render, staticRenderFns } from "./ModifyAddress.vue?vue&type=template&id=16120eed&scoped=true"
import script from "./ModifyAddress.vue?vue&type=script&lang=js"
export * from "./ModifyAddress.vue?vue&type=script&lang=js"
import style0 from "./ModifyAddress.vue?vue&type=style&index=0&id=16120eed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16120eed",
  null
  
)

export default component.exports